// extracted by mini-css-extract-plugin
export default {"ytButton":"YtButton_ytButton__0DA6a","svg":"YtButton_svg__TkJgW"};